import { SET_VIDEOS } from './actions';
import { fromJS } from 'immutable';

const initialState = fromJS({ videos: [] });

export default function videoFeedReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VIDEOS:
      return state.set('videos', fromJS(action.payload.videos));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/containers/VideoFeed/reducer.js